<div class="additional-information-container" *ngIf="!isHidden" 
  [formGroup]="form">
  <h3 class="title">{{'BOOKING_MODULE.ADDITIONAL_INFORMATION.TITLE' | transloco}}</h3>
  <p class="description">{{'BOOKING_MODULE.ADDITIONAL_INFORMATION.DESCRIPTION' | transloco}}</p>
  <div class="fieldset">
    <textarea placeholder="{{'BOOKING_MODULE.ADDITIONAL_INFORMATION.PLACEHOLDER' | transloco}}" rows="6" id="Comments" name="Comments"
      formControlName="Comments"></textarea>
  </div>
</div>